import axios from "axios";


function checkApiEndpoint(window_location_origin) {
    if (window_location_origin === "https://pitch.viaacademy.com") {
        return "https://api.viaacademy.io/v1/pitch/post/"
    } else if (window_location_origin === "https://qa-pitch.viaacademy.com") {
        return "https://qa-vfa.api.kaizhan.io/v1/pitch/post/"
    } else{
        return "https://qa-vfa.api.kaizhan.io/v1/pitch/post/"
    }
}

export async function getPitchData(pitchId) {

    const api_endpoint = checkApiEndpoint(window.location.origin)

    let pitchData = {}

    await axios.get(
        api_endpoint + pitchId,
        {
            headers: {
                "Accept": "application/json"
            }
        }
    ).then(response => {
        pitchData = response.data
    }).catch(
        error => {
            console.log("ERROR:")
            console.log(error)
            console.log(error.response.status)
            pitchData =  { "error": error.response.status}
        }
    )
    return pitchData
}

export async function getComments(pitchId) {

    const api_endpoint = checkApiEndpoint(window.location.origin)

    let comments = {}

    await axios.get(
        api_endpoint + pitchId + "/comments",
        {
            headers: {
                "Accept": "application/json"
            }
        }
    ).then(response => {
        comments = response.data
    }).catch(
        error => {
            console.log("ERROR:")
            console.log(error)
            console.log(error.response.status)
            comments =  { "error": error.response.status}
        }
    )
    return comments
}
